import React from 'react';
import { Typography } from '@material-ui/core';

function AdminUsers() {
  return (
    <div>
      <Typography variant="h5">
        Admin Users page is coming soon.
      </Typography>
    </div>
  );
}

export default AdminUsers;
